<template>
  <section class="hero-section">
    <div class="container">
      <div class="hero-content">
        <h1 class="hero-title">
          {{ $t('home.heroTitle') }}
        </h1>
        <p class="hero-subtitle">
          {{ $t('home.heroSubtitle') }}
        </p>
        <div class="hero-actions">
          <van-button
            class="gold-button"
            size="large"
            @click="goToVerification"
          >
            <van-icon name="certificate" />
            {{ $t('home.verifyNow') }}
          </van-button>
          <van-button
            class="blue-outline-button"
            size="large"
            @click="goToReport"
          >
            <van-icon name="shield-o" />
            {{ $t('home.reportFake') }}
          </van-button>
        </div>

        <div class="hero-features">
          <div class="feature-item">
            <van-icon
              name="checked"
              class="feature-icon"
            />
            <span>{{ $t('home.quickVerification') }}</span>
          </div>
          <div class="feature-item">
            <van-icon
              name="checked"
              class="feature-icon"
            />
            <span>{{ $t('home.security') }}</span>
          </div>
          <div class="feature-item">
            <van-icon
              name="checked"
              class="feature-icon"
            />
            <span>{{ $t('home.realTimeUpdates') }}</span>
          </div>
        </div>
      </div>

      <!--      <van-swipe-->
      <!--        :autoplay="3000"-->
      <!--        class="hero-image"-->
      <!--      >-->
      <!--        <van-swipe-item-->
      <!--          v-for="heroInfo in heroInfoList"-->
      <!--          :key="heroInfo.id"-->
      <!--        >-->
      <!--          <img-->
      <!--            :src="heroInfo?.coverPic"-->
      <!--            :alt="$t('home.heroImageAlt')"-->
      <!--            loading="lazy"-->
      <!--          >-->
      <!--          <div class="image-badge">-->
      <!--            <div-->
      <!--              class="badge-content"-->
      <!--              @click.stop="handleClickCodeScan(heroInfo)"-->
      <!--            >-->
      <!--              <van-icon name="scan" />-->
      <!--              <span>{{ $t('home.scanToExperience') }}</span>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </van-swipe-item>-->
      <!--      </van-swipe>-->
      <div
        v-for="heroInfo in heroInfoList"
        :key="heroInfo.id"
        class="hero-image"
      >
        <img
          :src="heroInfo?.coverPic"
          :alt="$t('home.heroImageAlt')"
          loading="lazy"
        >

        <div class="image-badge">
          <div
            class="badge-content"
            @click.stop="handleClickCodeScan(heroInfo)"
          >
            <van-icon name="scan" />
            <span>{{ $t('home.scanToExperience') }}</span>
          </div>
        </div>
      </div>

      <!--      <div class="hero-image">-->
      <!--        &lt;!&ndash; 轮播图容器 &ndash;&gt;-->
      <!--        <div class="carousel-container">-->
      <!--          <van-swipe-->
      <!--            class="product-carousel"-->
      <!--            :autoplay="4000"-->
      <!--            indicator-color="#1989fa"-->
      <!--          >-->
      <!--            <van-swipe-item-->
      <!--              v-for="product in heroInfoList"-->
      <!--              :key="product.id"-->
      <!--              class="carousel-item"-->
      <!--            >-->
      <!--              <div class="product-card">-->
      <!--                <div class="product-image-container">-->
      <!--                  <img-->
      <!--                    :src="product.coverPic"-->
      <!--                    :alt="product.name"-->
      <!--                    loading="lazy"-->
      <!--                    class="product-image"-->
      <!--                  >-->
      <!--                  &lt;!&ndash; 产品专属扫码按钮 &ndash;&gt;-->
      <!--                  <div-->
      <!--                    class="product-scan-btn"-->
      <!--                    @click.stop="handleProductScan(product)"-->
      <!--                  >-->
      <!--                    <van-icon name="scan" />-->
      <!--                    <span>{{ $t('home.scanThisProduct') }}</span>-->
      <!--                  </div>-->

      <!--                  &lt;!&ndash; 产品标签 &ndash;&gt;-->
      <!--                  <div class="product-tags">-->
      <!--                    <span-->
      <!--                      v-for="tag in product.tags"-->
      <!--                      :key="tag"-->
      <!--                      class="product-tag"-->
      <!--                    >-->
      <!--                      {{ tag }}-->
      <!--                    </span>-->
      <!--                  </div>-->
      <!--                </div>-->

      <!--                <div class="product-info">-->
      <!--                  &lt;!&ndash;                  <div class="product-header">&ndash;&gt;-->
      <!--                  &lt;!&ndash;                    <h4 class="product-name">&ndash;&gt;-->
      <!--                  &lt;!&ndash;                      {{ product.name }}&ndash;&gt;-->
      <!--                  &lt;!&ndash;                    </h4>&ndash;&gt;-->
      <!--                  &lt;!&ndash;                    <van-tag&ndash;&gt;-->
      <!--                  &lt;!&ndash;                      :color="product.statusColor"&ndash;&gt;-->
      <!--                  &lt;!&ndash;                      class="status-tag"&ndash;&gt;-->
      <!--                  &lt;!&ndash;                    >&ndash;&gt;-->
      <!--                  &lt;!&ndash;                      {{ product.status }}&ndash;&gt;-->
      <!--                  &lt;!&ndash;                    </van-tag>&ndash;&gt;-->
      <!--                  &lt;!&ndash;                  </div>&ndash;&gt;-->
      <!--&lt;!&ndash;                  <p class="product-desc">&ndash;&gt;-->
      <!--&lt;!&ndash;                    {{ product.description }}&ndash;&gt;-->
      <!--&lt;!&ndash;                  </p>&ndash;&gt;-->
      <!--                  &lt;!&ndash;                  <div class="product-details">&ndash;&gt;-->
      <!--                  &lt;!&ndash;                    <div class="detail-item">&ndash;&gt;-->
      <!--                  &lt;!&ndash;                      <van-icon name="clock" />&ndash;&gt;-->
      <!--                  &lt;!&ndash;                      <span>{{ $t('home.verificationTime') }}: {{ product.verificationTime }}</span>&ndash;&gt;-->
      <!--                  &lt;!&ndash;                    </div>&ndash;&gt;-->
      <!--                  &lt;!&ndash;                    <div class="detail-item">&ndash;&gt;-->
      <!--                  &lt;!&ndash;                      <van-icon name="shield" />&ndash;&gt;-->
      <!--                  &lt;!&ndash;                      <span>{{ $t('home.securityLevel') }}: {{ product.securityLevel }}</span>&ndash;&gt;-->
      <!--                  &lt;!&ndash;                    </div>&ndash;&gt;-->
      <!--                  &lt;!&ndash;                  </div>&ndash;&gt;-->
      <!--                </div>-->
      <!--              </div>-->
      <!--            </van-swipe-item>-->
      <!--          </van-swipe>-->

      <!--          &lt;!&ndash; 轮播控制按钮 &ndash;&gt;-->
      <!--          <div class="carousel-controls">-->
      <!--            <button-->
      <!--              class="control-btn prev-btn"-->
      <!--              :disabled="currentSlide === 0"-->
      <!--              @click="prevSlide"-->
      <!--            >-->
      <!--              <van-icon name="arrow-left" />-->
      <!--            </button>-->
      <!--            <div class="slide-counter">-->
      <!--              {{ currentSlide + 1 }} / {{ heroInfoList.length }}-->
      <!--            </div>-->
      <!--            <button-->
      <!--              class="control-btn next-btn"-->
      <!--              :disabled="currentSlide === heroInfoList.length - 1"-->
      <!--              @click="nextSlide"-->
      <!--            >-->
      <!--              <van-icon name="arrow" />-->
      <!--            </button>-->
      <!--          </div>-->
      <!--        </div>-->

      <!--        &lt;!&ndash; 产品指示器 &ndash;&gt;-->
      <!--        <div class="product-indicators">-->
      <!--          <div-->
      <!--            v-for="(product, index) in heroInfoList"-->
      <!--            :key="index"-->
      <!--            class="indicator"-->
      <!--            :class="{ active: currentSlide === index }"-->
      <!--            @click="goToSlide(index)"-->
      <!--          >-->
      <!--            <div class="indicator-image">-->
      <!--              <img-->
      <!--                :src="product.url"-->
      <!--                :alt="product.name"-->
      <!--              >-->
      <!--            </div>-->
      <!--            <span class="indicator-label">{{ product.name }}</span>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

      <!-- 二维码弹窗 -->
      <van-popup
        v-model:show="isCodeScan"
        round
        closeable
        position="center"
        :style="{ width: '90%', maxWidth: '320px' }"
        @click-close="isCodeScan = false"
      >
        <div class="qr-popup-content">
          <h3 class="qr-title">
            {{ $t('home.scanToExperience') }}
          </h3>
          <div class="qr-code-container">
            <img
              :src="selectedProduct?.feedbackPic"
              alt="QR Code"
              class="qr-code-image"
            >
          </div>
          <p class="qr-description">
            {{ $t('home.scanDescription') }}
          </p>
          <van-button
            class="close-button"
            type="primary"
            size="small"
            @click="isCodeScan = false"
          >
            {{ $t('common.close') }}
          </van-button>
        </div>
      </van-popup>
    </div>
  </section>
</template>

<script lang="ts">
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { defineComponent, onMounted, ref, watch } from 'vue'
import { CommodityDemo, queryCommodityDemoList } from '@/api/home'
export default defineComponent({
  setup () {
    const router = useRouter()
    const isCodeScan = ref(false)

    const { locale } = useI18n()
    watch(locale, () => {
      getHeroInfoList()
    })
    // 扫码事例
    const heroInfoList = ref<CommodityDemo[]>([])
    const getHeroInfoList = () => {
      // 获取heroInfoList
      queryCommodityDemoList().then(res => {
        heroInfoList.value = res.list
      })
    }

    // 获取全局的 $t 方法
    // const $t = instance?.appContext.config.globalProperties.$t
    const goToVerification = () => {
      router.push({
        path: '/verification'
        // query: {
        //   code: '05904AFB8DED48009688EA0143AA2C5A'
        // }
      })
    }

    const goToReport = () => {
      router.push('/report')
    }

    const handleClickCodeScan = (product: CommodityDemo) => {
      isCodeScan.value = !isCodeScan.value
      selectedProduct.value = product
    }

    const currentSlide = ref(0)
    const prevSlide = () => {
      if (currentSlide.value > 0) {
        currentSlide.value--
      }
    }
    const nextSlide = () => {
      if (currentSlide.value < heroInfoList.value.length - 1) {
        currentSlide.value++
      }
    }

    const selectedProduct = ref<CommodityDemo | null>(null)
    const handleProductScan = (product: CommodityDemo) => {
      selectedProduct.value = product
    }

    onMounted(() => {
      getHeroInfoList()
    })
    return {
      heroInfoList,
      goToVerification,
      goToReport,
      isCodeScan,
      handleClickCodeScan,
      currentSlide,
      prevSlide,
      nextSlide,
      handleProductScan,
      selectedProduct
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.hero-section {
  padding: $spacing-xxl;
  display: flex;
  align-items: center;
  min-height: 80vh;
  position: relative;
  overflow: hidden;

  .container {
    display: flex;
    align-items: center;
    position: relative;
    z-index: 2;
  }
}

.hero-content {
  flex: 1;
  padding-right: $spacing-xl;
}

.hero-title {
  font-size: $font-size-xxxl;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: $spacing-lg;
  color: $primary-blue;
}

.hero-subtitle {
  font-size: $font-size-lg;
  color: $text-light;
  margin-bottom: $spacing-xxl;
  line-height: 1.6;
}

.hero-actions {
  display: flex;
  gap: $spacing-md;
  margin-bottom: $spacing-xl;
}

.hero-features {
  display: flex;
  gap: $spacing-lg;
}

.feature-item {
  display: flex;
  align-items: center;
  font-size: $font-size-sm;
  color: $text-light;

  .feature-icon {
    color: $accent-gold;
    margin-right: $spacing-xs;
  }
}

.hero-image {
  flex: 1;
  display: flex;
  justify-content: center;
  position: relative;

  img {
    max-width: 100%;
    border-radius: $border-radius-lg;
    box-shadow: $card-shadow;
    transform: perspective(800px) rotateY(-5deg);
    transition: transform $transition-normal;

    &:hover {
      transform: perspective(800px) rotateY(0);
    }
  }
}

.image-badge {
  position: absolute;
  bottom: 20px;
  right: 20px;
  background: rgba($white, 0.95);
  padding: $spacing-sm $spacing-md;
  border-radius: $border-radius;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);

  .badge-content {
    display: flex;
    align-items: center;
    font-weight: 500;
    color: $primary-blue;

    .van-icon {
      margin-right: $spacing-xs;
      color: $accent-gold;
    }
  }
}

.qr-popup-content {
  padding: $spacing-lg;

  .qr-code-container .qr-code-image {
    width: 180px;
    height: 180px;
  }
}

// 1080×1920 设备适配
@media (min-width: 1080px) and (min-height: 1920px) {
  .hero-section {
    min-height: 70vh;
    flex-direction: column;
    text-align: center;

    .container {
      flex-direction: column;
    }
  }

  .hero-content {
    padding-right: 0;
    margin-bottom: $spacing-xl;
  }

  .hero-title {
    font-size: 3.2rem;
  }

  .hero-subtitle {
    font-size: $font-size-xl;
  }

  .hero-actions {
    justify-content: center;
  }

  .hero-features {
    justify-content: center;
  }

  .hero-image {
    margin-top: $spacing-xl;

    img {
      max-width: 80%;
    }
  }
}

// 平板设备
@media (max-width: $breakpoint-lg) {
  .hero-title {
    font-size: $font-size-xxl;
  }

  .hero-subtitle {
    font-size: $font-size-md;
  }
}

// 移动端适配
@media (max-width: $breakpoint-md) {
  .hero-section {
    flex-direction: column;
    text-align: center;
    padding: $spacing-xl 0;

    .container {
      flex-direction: column;
    }
  }

  .hero-content {
    padding-right: 0;
    margin-bottom: $spacing-xl;
  }

  .hero-title {
    font-size: $font-size-xl;
  }

  .hero-actions {
    flex-direction: column;
    align-items: center;
  }

  .hero-actions .gold-button,
  .hero-actions .blue-outline-button {
    width: 100%;
    max-width: 300px;
    //background: linear-gradient(135deg, $accent-gold 0%, darken($accent-gold, 5%) 100%);
  }

  .hero-features {
    flex-direction: column;
    gap: $spacing-sm;
    align-items: center;
  }

  .image-badge {
    bottom: 10px;
    right: 10px;
    padding: $spacing-xs $spacing-sm;

    .badge-content {
      font-size: $font-size-xs;
    }
  }
}

// 超小屏幕设备
@media (max-width: $breakpoint-sm) {
  .hero-title {
    font-size: $font-size-lg;
  }

  .hero-subtitle {
    margin-bottom: $spacing-xl;
    font-size: $font-size-sm;
  }

  .hero-actions {
    margin-bottom: $spacing-lg;
  }
}

// 横屏模式适配
@media (max-height: 500px) and (orientation: landscape) {
  .hero-section {
    min-height: 100vh;
  }

  .hero-title {
    font-size: $font-size-xl;
  }

  .hero-subtitle {
    margin-bottom: $spacing-lg;
  }

  .hero-features {
    display: none;
  }
}
</style>
